import useMountEffect from '@restart/hooks/useMountEffect';
import classNames from 'classnames/bind';
import React, { useRef } from 'react';

import styles from './console.module.scss';
import ProcessingButton from '../ProcessingButton';

import useCalibrationCommand from '@/hooks/command/mavlink/useCalibrationCommand';
import EventEmitter from '@/libs/EventEmitter';

const cx = classNames.bind(styles);

const Panel = ({ robot }) => {
  const subscribeToken = useRef();
  const calibrationCommand = useCalibrationCommand();

  useMountEffect(() => {
    return () => {
      unsubscribe();
    };
  });

  const unsubscribe = () => {
    if (subscribeToken.current) {
      EventEmitter.unsubscribe(subscribeToken.current);
      subscribeToken.current = null;
    }
  };

  const doStart = () => {
    return new Promise((resolve) => {
      subscribeToken.current = EventEmitter.subscribe(`${robot.id}/telemetry/commandAck`, (data) => {
        // 241: MAV_CMD_PREFLIGHT_CALIBRATION
        if (data.command === 241) {
          unsubscribe();
          resolve(true);
        }
      });

      calibrationCommand.levelHorizon(robot);
    });
  };

  return (
    <div className={cx('container')}>
      <div className={cx('message')}>Place your vehicle in its level flight position.</div>
      <ProcessingButton text="Start" doProcess={doStart} />
    </div>
  );
};

export default Panel;
